import styled from "styled-components";
import VerticallyCentered from "./VerticallyCentered";

export default styled(VerticallyCentered)`
    justify-content: space-between;
`;
